var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form-register",
      attrs: { method: "post", action: _vm.regionRelativeUrl("/users/login/") },
      on: { submit: _vm.authenticate }
    },
    [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("live-country-component", {
            attrs: { "post-fix-path": "/users/login/" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "span",
          {
            staticClass: "error-input-container",
            class: {
              "has-error":
                _vm.$v.auth.email.$error &&
                _vm.formSubmitted &&
                (!_vm.$v.auth.email.required || !_vm.$v.auth.email.email)
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.$v.auth.email.$model,
                  expression: "$v.auth.email.$model",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "inputEmail",
                placeholder: _vm.translate.login.emailOrPhoneLogin,
                name: "email",
                autocomplete: "off"
              },
              domProps: { value: _vm.$v.auth.email.$model },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.$v.auth.email,
                    "$model",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.$v.auth.email.$error || _vm.formSubmitted
          ? _c(
              "span",
              [
                !_vm.$v.auth.email.required
                  ? _c("error-component", {
                      attrs: { message: _vm.translate.login.emailRequired }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c(
          "span",
          {
            staticClass: "error-input-container",
            class: {
              "has-error":
                (_vm.$v.auth.password.$error || _vm.formSubmitted) &&
                !_vm.$v.auth.password.required
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.$v.auth.password.$model,
                  expression: "$v.auth.password.$model",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                id: "inputPassword",
                placeholder: _vm.translate.login.password,
                name: "password"
              },
              domProps: { value: _vm.$v.auth.password.$model },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.$v.auth.password,
                    "$model",
                    $event.target.value.trim()
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.$v.auth.password.$error || _vm.formSubmitted
          ? _c(
              "span",
              [
                !_vm.$v.auth.password.required
                  ? _c("error-component", {
                      attrs: { message: _vm.translate.login.passwordRequired }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "two-column-grid" },
        [
          _c(
            "a",
            {
              staticClass: "teal-text-button d-flex align-items-center",
              attrs: { href: _vm.regionRelativeUrl("/users/forgot-password/") }
            },
            [_vm._v(_vm._s(_vm.translate.login.forgotPassword))]
          ),
          _vm._v(" "),
          _c("button-with-loading-component", {
            staticClass: "btn btn-primary btn-block",
            attrs: {
              disabled: _vm.$v.$anyDirty && _vm.$v.$invalid,
              type: "submit",
              text: _vm.translate.login.login,
              loading: _vm.loading
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1b08a8e", { render: render, staticRenderFns: staticRenderFns })
  }
}